import { Translation } from '@shared/types/translation';

export const ADMIN_ERROR_MESSAGES = {
  PRIVILEGE_REQUIRED: {
    english: 'Please select at least one privilege to add the user.',
    polish: 'Wybierz co najmniej jedno uprawnienie, aby dodać użytkownika.',
  },
} as const satisfies Record<string, Translation>;
